import React, {useState} from 'react'
import './CalendarMain.scss'
import Calendar from './CalendarParts'
import moment from 'moment'

const CalendarMain = () => {
  return <Calendar />
}

export default CalendarMain
